export default {
  title: 'Nouvelle catégorie',
  form: {
    menus: {
      label: 'Menus',
    },
    printer: {
      label: 'Imprimante',
    },
    type: {
      label: 'Type',
    },
    name: {
      label: 'Nom',
      placeholder: 'Saisir le nom de la catégorie',
    },
    description: {
      label: 'Description',
      placeholder: 'Saisir une description',
    },
    has_combo_tax: {
      label: 'Taxe combo',
    },
    modifier_groups: {
      label: 'Groupes de modificateurs',
    },
    image: {
      label: 'Image',
    },
    identifiers: {
      label: 'Identifiants',
    },
    has_separate_schedule: {
      label: 'Varie selon le planning du menu',
    },
  },
  buttons: {
    save: 'Enregistrer',
    close: 'Fermer',
  },
  feedback: {
    missing_info: 'Informations manquantes',
  },
  toasts: {
    category_got_created: 'Catégorie créée',
    category_got_updated: 'Catégorie mise à jour',
  },
};
